<template>
  <div class="broadcast" v-if="lotteryShowAwardInfoBeforeAnswering">
    <div class="mb-4">
      <span class="broadcast-title">抽奖</span>
    </div>
    <div>
      <div class="broadcast-item">
        <div class="broadcast-label">奖品</div>
        <div
            class="broadcast-value relative"
            :class="{ truncate: closePrizeContent, 'pr-5': showPrizeSwitchArrow }"
            ref="prizeContent"
        >
          <span>{{ lotteryContent }}</span>
          <div class="prize-arrow" v-if="showPrizeSwitchArrow" @click="onChangeArrow">
            <span>
              <i :class="closePrizeContent ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
            </span>
          </div>
        </div>
      </div>
      <div class="broadcast-item" v-if="lotteryAwardPresentationDescribe">
        <div class="broadcast-label">发奖方式</div>
        <div class="broadcast-value">{{ lotteryAwardPresentationDescribe }}</div>
      </div>
      <div class="broadcast-item">
        <div class="broadcast-label">温馨提醒</div>
        <div class="broadcast-value">奖品由发布者负责提供和发放</div>
      </div>
    </div>
    <div class="broadcast-info" v-if="lotteryAwardSends.length">
      <div class="broadcast-item">
        <div class="broadcast-label">获奖名单</div>
        <div class="broadcast-value broadcast-info-content">
          <el-carousel height="20px" direction="vertical" :autoplay="true">
            <el-carousel-item v-for="(item, index) in lotteryAwardSends" :key="index">
              <div>
                <span>{{ item.text }}</span>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div v-if="lotteryIsExpired">
      <div class="broadcast-item">
        <div class="broadcast-label"></div>
        <div class="broadcast-value">
          <span class="text-danger">
            <i class="el-icon-warning-outline"></i>
          </span>
          <span class="text-danger ml-1">抽奖已经于 {{ lotteryDeadline }} 结束</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Broadcast',
  data() {
    return {
      closePrizeContent: false,
      showPrizeSwitchArrow: false
    }
  },
  computed: {
    lotteryShowAwardInfoBeforeAnswering() {
      return this.$bus.lottery.lotteryShowAwardInfoBeforeAnswering
    },
    lotteryContent() {
      const lotteryAwards = this.$bus.lottery.lotteryAwards || []
      return lotteryAwards.map((award) => {
        switch (award.lotteryCategory) {
          case 1:
          case 2:
          case 3:
          case 5:
            return award.awardName
          case 4:
            return `微信红包`
        }
        return ''
      }).join('，')
    },
    lotteryAwardSends() {
      if (!this.$bus.lottery.lotteryShowWinningListBeforeAnswering) return []
      const lotteryAwards = this.$bus.lottery.lotteryAwards || []
      const phoneReg = /\d{3}(\d{4})\d{4}/
      return (this.$bus.lottery.lotteryAwardSends || []).map(award => {
        // let t = lotteryAwards.find(item => item.gridNo === award.gridNo)
        // if (!t) return null
        const accountUserName = (award.accountUserName||'').slice(0, 1) + '**'
        const accountUserPhone = (award.accountUserPhone||'').replace(phoneReg, '****')
        return {
          text: `${accountUserName} （${accountUserPhone}） 于 ${award.createTime} 成功抽到 ${award.awardName}`
        }
      }).filter(Boolean)
    },
    lotteryAwardPresentationDescribe() {
      return this.$bus.lottery.lotteryAwardPresentationDescribe
    },
    lotteryIsExpired() {
      return this.$bus.lottery.lotteryExpired
    },
    lotteryDeadline() {
      return this.$bus.lottery.lotteryDeadline
    }
  },
  methods: {
    init() {
      // 22 为 1行高度
      const el = this.$refs.prizeContent
      if (el.clientHeight <= 22) {
        this.showPrizeSwitchArrow = false
        return
      }
      this.closePrizeContent = true
      this.showPrizeSwitchArrow = true
    },
    onChangeArrow() {
      this.closePrizeContent = !this.closePrizeContent
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style scoped lang="scss">
@import '~@/assets/scss/mixin.scss';

.broadcast {
  padding: 16px 40px;
  @apply bg-card-bg-gray;
  &-title {
    font-size: 16px;
    @apply font-bold font-MEDIUM;
  }

  @include useLabelItem('.broadcast');

  .broadcast-label {
    margin-right: 16px;
    color: rgba(0, 0, 0, .45);
  }

  .broadcast-info {
    border-top: 1px solid rgba(0, 0, 0, 0.05);
    padding-top: 16px;
    margin-top: 16px;
  }

  .prize-arrow {
    position: absolute;
    top: 0;
    height: 22px;
    line-height: 22px;
    right: 0;
    width: 20px;
    text-align: center;
    cursor: pointer;
    @apply bg-card-bg-gray;
  }
}
</style>
